import React, { Component } from 'react';
import TrackHistory from 'common/analytics/TrackHistory';
import AnalyticsProvider from 'common/analytics/AnalyticsProvider';

export default class TrackingSetup extends Component {
  render() {
    return (
      <AnalyticsProvider ssr={this.props.ssr}>
        <TrackHistory>{this.props.children}</TrackHistory>
      </AnalyticsProvider>
    );
  }
}
